// Custom VFG components
// fancyCheckbox1 data area

<template>
    <div class="wrapper field-input">
        <div>
            <input :id="id"   :autocomplete="schema.autocomplete" :disabled="disabled" v-model="value" type="checkbox" class="with-font"  :name="schema.inputName"/>
            <label :for="id">{{schema.text}}</label>
        </div>
    </div>

</template>
 
<script>
    export default {
        props: [],
        name: 'fancyCheckbox1',
        mixins: [ VueFormGenerator.abstractField],
        methods: {
            // triggerValidation() {
            //     this.validate();
            // }
        }
        ,
        mounted () {
            this.id=this._uid
        }
        ,
        data() {
            return {
                id: null
            }
        }
    }
</script>

<style scoped >


input[type=checkbox] {
    display: none;
}

/* to hide the checkbox itself */
input[type=checkbox]+label:before {
    font-family: FontAwesome;
    display: inline-block;
    content: "\f096";
    letter-spacing: 10px;
    font-size: 1.8em;
    position: relative;
    top: 4px;
}


input[type=checkbox]:checked+label:before {
    content: "\f046";
        letter-spacing: 6px;
}


</style>


